<template>
    <div class="audio-box"
         :class="{search: isSearch, active: isSearch && item.play}"
         @click.stop="handleSelectItem(item, index, index1)"
    >
        <p class="title-box">
            <span class="name" :alt="item.name">{{item.alias || item.name}}</span>
            <span class="time">{{item.time}}</span>
        </p>
        <div class="btn-box">
            <div class="btns">
                <p class="btn play">
                    <span v-if="!item.play"
                          class="iconfont icon-bofang_huise one"
                    ></span>
                    <span v-if="item.play"
                          class="iconfont icon-zanting_heise two"
                    ></span>
                </p>
            </div>
            <p class="btn select-box">
                <el-button
                    class="theme-btn"
                    size="mini"
                    @click.native.stop="handleSetBackground(item,index,index1)"
                >设为背景音</el-button>
                <el-button
                    class="theme-btn"
                    size="mini"
                    @click.native.stop="handleStatus(item,index,index1)"
                >添加</el-button>
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "audioBox",
        props: {
            isSearch: {
                type: Boolean,
                default: false
            },
            item: Object,
            index: [String, Number],
            index1: [String, Number],
        },
        methods: {
            handlePlay (item, index, index1) {
                this.handleMouseEnterOpen();
                this.$emit('handlePlay', item, index, index1)
            },
            handleSetBackground(item, index, index1){
                this.handleMouseEnterOpen();
                this.$emit('handleSetBackground', item, index, index1)
            },
            handleStatus (item, index, index1) {
                this.handleMouseEnterOpen();
                this.$emit('handleStatus', item, index, index1)
            },
            handleSelectItem (item, index, index1) {
                this.handleMouseEnterOpen();
                console.log('handleSelectItem==>', item, index, index1)
                this.handlePlay(item, index, index1)
                //this.$emit('handleSelectItem', item, index, index1)
            },
            handleMouseEnterOpen(){
                this.$store.state.menusKeyBoard=false;//当前是可操作焦点
            },
        }
    }
</script>

<style lang="scss" scoped>
.audio-box{

    &.search {
        width: 100%;
        height: 60px;
        /*margin-bottom: 10px;*/
        transition: all .2s linear;

        background: rgba(250, 250, 250, 1);
        border-radius: 4px;
        border: 1px solid rgba(232, 232, 232, 1);

        &:hover, &.active {
            cursor: pointer;
            border: 1px solid #e7622e;
        }
    }

    .title-box {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .name {
            height: 18px;
            font-size: 14px;
            color: rgba(51, 51, 51, 1);
            padding-left: 10px;
            padding-top: 6px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 212px;
        }

        .time {
            font-size: 14px;
            padding-right: 10px;
            padding-top: 6px;
        }
    }

    .btn-box {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 6px 10px 0px;

        .btns {
            display: flex;
            flex-direction: row;

            .btn {
                margin-right: 15px;
            }
        }

        .btn {
            display: flex;
            cursor: pointer;

            &.play{

                .one {
                    font-size: 18px;
                    color: rgba(51,51,51,.3);
                }
                .two{
                    font-size: 18px;
                    color: #333333;
                }
            }
            &.select-box {
                .one {
                    width:18px;
                    height:18px;
                    border-radius:4px;
                    border:1px solid rgba(232,232,232,1);
                    background-color: white;
                }
                .two {
                    width:18px;
                    height:18px;
                    border-radius:4px;
                    border:1px solid #e7622e;
                    background-color: #e7622e;

                    .gou{
                        color: white;
                        position: relative;
                        top: -1px;
                        left: 0px;
                        font-size: 18px;
                    }
                }
            }
            &.play > img {
                width: 20px;
                height: 21px;
            }

            &.love > img {
                width: 20px;
                height: 18px;
                margin-top: 1px;
            }

            &.select-box > img {
                width: 18px;
                height: 19px;
            }
        }
    }
}
    .select-box /deep/ .el-button--mini, .el-button--mini.is-round{
        padding: 6px 8px;
    }
</style>
